import React from 'react';
import {IsF, IsM, IsMP, IsSM, IsSP, IsT} from "my-styles/media/media";
import {useHistory} from "react-router-dom";

export default function ArticleBox(props) {
    const history = useHistory()
    let height = IsSM() ? '70' : IsM() ? '60' : IsF() ? '65' : IsMP() ? '56' : '52';


    return (
        <div className={"card clickable  marginSmall"} style={{
            height: props.heightUnit, width: props.width,
            display: "inline-block",
            verticalAlign: 'top',

        }}>
            <div style={{height: height + '%'}} onClick={() => {
                props.onNavigate(history, "/article?id=" + props.article.id)
            }}>
                <img src={props.article.image} alt={props.article.title} className="clickable fullWidth"
                     style={{borderRadius: '0.5rem', height: '100%'}}/>
                <div className={"dateBox"}>
                    <span className={"textBold "}>{props.article.day_shamsi_start_date}</span>
                    <span className={" textBold "}>{props.article.month_shamsi_start_date}</span>
                </div>
            </div>
            <div className={"textCenter"} style={{marginTop: IsSM() || IsM() || IsF() || IsT() ? props.article.title.length>18? '0rem' :'0.6rem ':'1rem',display:'flex',justifyContent:'center',alignItems:'center'}} onClick={() => {
                props.onNavigate(history, "/article?id=" + props.article.id)
            }}>
                <p className={IsSM() || IsM() || IsF() || IsT() || IsSP() ? "mediumTextBold marginSmall " : "largeTextBold marginSmall "}
                   style={{
                       whiteSpace: 'break-spaces',
                       marginTop: IsSM() || IsM() || IsF() ? '0' : '0'
                   }}>{props.article.title}</p>
                {IsSM() || IsM() || IsF() ? <p/> :
                    <div style={{padding: '0 0.4rem',width:'90%', whiteSpace: 'normal'}}>
                        <p className={"mediumText marginSmall textBoxArticle card-text "} style={{margin:'0',marginTop:'-19px'}}
                           dangerouslySetInnerHTML={{__html: props.article.description}}/>
                    </div>}

            </div>
        </div>
    )
}